export const CATEGORY_LINKS = [
  { label: "Flowers", slug: "flower-strains" },
  { label: "Pre-Rolls", slug: "pre-rolls" },
  { label: "Edibles", slug: "edibles" },
  { label: "Disposable Carts", slug: "disposables-carts" },
  { label: "Concentrates", slug: "concentrates" },
  { label: "Cartridges", slug: "cartridges" },
  { label: "Shatter", slug: "shatter" },
  { label: "Deals", slug: "special-deals" },
];
